import { useEffect, useState } from 'react';
import { TUseTransferModalDataProps } from '../type';

const useTransferModalData = (props: TUseTransferModalDataProps) => {
  const {
    leftOptions,
    rightOptions,
    primaryKey = 'id',
    quickKey = 'type',
    quickValue,
    searchOptions,
    onSearch,
    onSearchValueChange,
    onChangeQuickOptions,
    onClickLeftOption,
    onClearAllOption: propsOnClearAllOption,
    onClearSearch: propsOnClearSearch,
    filter,
    filterRender,
    maxLength,
  } = props;

  // 左侧数据
  const [currentLeftOptions, setCurrentLeftOptions] = useState<any[]>([]);

  // 左侧搜索提示数据
  const [currentSearchOptions, setCurrentSearchOptions] = useState<any[]>([]);

  // 右侧数据
  const [currentRightOptions, setCurrentRightOptions] = useState<any[]>([]);

  // 当前快捷选项值
  const [currentQuickValue, setCurrentQuickValue] = useState<any[]>([]);

  useEffect(() => {
    if (leftOptions) {
      setCurrentLeftOptions(leftOptions);
    }
  }, [leftOptions]);

  useEffect(() => {
    if (searchOptions) {
      setCurrentSearchOptions(searchOptions);
    }
  }, [searchOptions]);

  useEffect(() => {
    if (rightOptions) {
      let rightOptionList = rightOptions;
      // 超出限制只取前最大数
      if (maxLength && rightOptions.length > maxLength) {
        rightOptionList = rightOptions?.slice(0, maxLength);
      }
      setCurrentRightOptions(rightOptionList);
    }
  }, [rightOptions, maxLength]);

  useEffect(() => {
    if (quickValue) {
      setCurrentQuickValue(quickValue);
    }
  }, [quickValue]);

  // 搜索值变化触发
  const onSearchChange = (value?: string) => {
    if (typeof onSearchValueChange === 'function') {
      onSearchValueChange?.(value);
    } else {
      const filterOptions = leftOptions?.filter((item) =>
        item.text?.includes(value),
      );
      setCurrentSearchOptions(filterOptions || []);
    }
  };

  // 搜索框回车、点搜索触发
  const onSearchEnter = (value?: string) => {
    if (!value) {
      return;
    }
    if (typeof onSearch === 'function') {
      onSearch(value);
      return;
    }
    let filterOptions: any;
    if (typeof filter === 'function') {
      filterOptions = filter(value, leftOptions);
    } else {
      filterOptions = leftOptions?.filter((item) => item.text?.includes(value));
    }
    setCurrentLeftOptions(filterOptions || []);
  };

  // 点击快捷选项触发
  const onClickQuickOption = (currValue: string) => {
    const hasValue = currentQuickValue?.includes(currValue);
    if (maxLength && currentRightOptions.length >= maxLength && !hasValue) {
      return;
    }
    const values = hasValue
      ? currentQuickValue?.filter((val) => val !== currValue)
      : [...currentQuickValue, currValue];
    setCurrentQuickValue(values);

    if (typeof onChangeQuickOptions === 'function') {
      // 待优化，只传values-------------
      onChangeQuickOptions(currValue, hasValue, values);
      return;
    }

    let filterRightOptions;
    // 已选则过滤掉，无则添加
    if (hasValue) {
      filterRightOptions = currentRightOptions?.filter(
        (item) => item[quickKey] !== currValue,
      );
    } else {
      filterRightOptions = leftOptions?.filter(
        (item) => item[quickKey] === currValue,
      );
    }
    setCurrentRightOptions(filterRightOptions || []);
  };

  // 清除搜索框
  const onClearSearch = () => {
    propsOnClearSearch?.();
    setCurrentLeftOptions(leftOptions || []);
  };

  // 勾选、取消勾选左侧选项触发
  const onCheckLeftOption = (checked: boolean, option: any) => {
    if (maxLength && currentRightOptions.length >= maxLength && checked) {
      return;
    }
    // 外部事件处理
    if (typeof onClickLeftOption === 'function') {
      onClickLeftOption(checked, option);
      return;
    }
    // 内部事件处理
    let filterRightOptions;
    if (!checked) {
      filterRightOptions = currentRightOptions?.filter(
        (item) => item[primaryKey] !== option[primaryKey],
      );
    } else {
      const checkOption = currentLeftOptions?.filter(
        (item) => item[primaryKey] === option[primaryKey],
      );
      filterRightOptions = [...currentRightOptions, ...checkOption];
    }
    const newCurrentLeftOptions = currentLeftOptions?.map((item) => {
      if (item[primaryKey] === option[primaryKey]) {
        item.checked = checked;
      }
      return item;
    });
    setCurrentLeftOptions(newCurrentLeftOptions);
    setCurrentRightOptions(filterRightOptions);
    if (filterRightOptions.length === 0) {
      setCurrentQuickValue([]);
    }
  };

  // 删除右侧选项触发
  // const onRemoveRightOption = (option: any) => {
  //   const filterRightOptions = currentRightOptions?.filter(
  //     (item) => item[primaryKey] !== option[primaryKey],
  //   );
  //   setCurrentRightOptions(filterRightOptions);
  // };

  // 右侧清除选项触发
  const onClearAllOption = () => {
    propsOnClearAllOption?.();
    setCurrentQuickValue([]);
    setCurrentRightOptions([]);
    // 清空左侧选项勾选状态
    const newLeftOptions = currentLeftOptions.map((item) => ({
      ...item,
      checked: false,
    }));
    setCurrentLeftOptions(newLeftOptions);
  };

  return {
    currentLeftOptions,
    currentRightOptions,
    currentSearchOptions,
    currentQuickValue,
    onSearchChange,
    onSearchEnter,
    onClickQuickOption,
    onClearSearch,
    onCheckLeftOption,
    // onRemoveRightOption,
    onClearAllOption,
  };
};

export default useTransferModalData;
